<form [formGroup]="fullName" class="row mx-n3 mb-3 selenium-personal-info">
    <div class="col-md-6 p-3">
        <div class="p-2 border rounded-lg border-dark bg-transparent selenium-first-name">
            <label for="firstName" class="m-0 text-primary font-weight-bold font-size-14"
                >First Name</label
            >
            <input
                [attr.disabled]="isDisabled"
                type="text"
                class="form-control font-size-18 text-darker-grey border-0 pl-0"
                id="firstName"
                formControlName="firstName"
            />
        </div>
    </div>
    <div class="col-md-6 p-3">
        <div class="p-2 border rounded-lg border-dark bg-transparent selenium-last-name">
            <label for="lastName" class="m-0 text-primary font-weight-bold font-size-14"
                >Last Name</label
            >
            <input
                [attr.disabled]="isDisabled"
                type="text"
                class="form-control font-size-18 text-darker-grey border-0 pl-0"
                id="lastName"
                formControlName="lastName"
            />
        </div>
    </div>
</form>
